/**
 * Every page branches on the business tag, never on message text — the
 * messages are server-authored English and change without notice.
 * A gateway that returns HTML, or a request that never reached the server
 * at all, must read as "no tag" rather than crash the handler that asked.
 */
export const tagOf = (error: unknown): string | null => {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (!data || typeof data !== "object") return null;
  const tag = (data as { error?: { tag?: unknown } })?.error?.tag;
  return typeof tag === "string" ? tag : null;
};
